var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast",class:{
    visible: _vm.visible,
  }},[_c('div',{staticClass:"toast__text"},[_vm._v(" "+_vm._s(_vm.aplicacion.languageSel == "fr" ? "Copié dans le presse-papier" : _vm.aplicacion.languageSel == "en" ? "Copied to clipboard" : "")+" ")]),_c('img',{staticClass:"toast__image",attrs:{"src":_vm.RequireImage('Global/Success.svg'),"alt":""},on:{"load":function($event){return _vm.OnLoadImage($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }